/**
 * 「我正在去的那一单」。
 *
 * ★ 为什么要单独存一份:司机点导航的那一刻,就等于宣布了他要去哪一单 ——
 *   而这件事发生在**详情页**里,「今日」那一屏却要据此把那一单顶出来。
 *   两个屏之间没有父子关系,靠 props 传的话得穿过 App 再穿回来。
 *
 * ★ 存进 localStorage:他中途切到导航 App、回来时页面可能已经重载,
 *   而「我刚才要去的是哪一单」不该因此丢掉 —— 那正是他回来要找的东西。
 *
 * ★ 只存 id,不存整单。订单状态随时会变(别人改派、他自己取货),
 *   存一份快照的话,回来看到的会是旧的。
 */

const KEY = 'delivery.driver.currentOrder';

type Listener = (id: string | null) => void;
const listeners = new Set<Listener>();

export const currentOrder = {
  get(): string | null {
    try {
      return localStorage.getItem(KEY);
    } catch {
      // 隐私模式下 localStorage 可能抛 —— 不该让整屏挂掉
      return null;
    }
  },

  set(id: string | null): void {
    try {
      if (id) localStorage.setItem(KEY, id);
      else localStorage.removeItem(KEY);
    } catch {
      /* 同上:存不下就只在内存里生效 */
    }
    for (const l of listeners) l(id);
  },

  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
